var React = require('react');

function FolderCheck (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M23.8 4.18h-8.792l-.448-1.393A4.2 4.2 0 0 0 10.584 0H4.2C1.88 0 0 1.872 0 4.18v18.117c0 2.309 1.88 4.18 4.2 4.18h19.6c2.32 0 4.2-1.871 4.2-4.18V8.36c0-2.309-1.88-4.18-4.2-4.18m1.4 18.117c0 .77-.627 1.393-1.4 1.393H4.2c-.773 0-1.4-.624-1.4-1.393V4.18c0-.77.627-1.394 1.4-1.394h6.384a1.4 1.4 0 0 1 1.33.948l.756 2.285a1.4 1.4 0 0 0 1.33.948h9.8c.773 0 1.4.624 1.4 1.393z","fill":"#008FD5","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"M17.206 11.553 12.6 16.15l-1.806-1.811a1.41 1.41 0 0 0-1.988 0 1.395 1.395 0 0 0 0 1.978l2.8 2.788a1.403 1.403 0 0 0 1.988 0l5.6-5.575a1.395 1.395 0 0 0 0-1.978 1.41 1.41 0 0 0-1.988 0","fill":"#01C0F3","key":1})]));
}

FolderCheck.defaultProps = {"width":"28","height":"27","viewBox":"0 0 28 27"};

module.exports = FolderCheck;

FolderCheck.default = FolderCheck;
